import { signal } from '@codegrade/utils';
/** Emitted after a user has been logged out. */
export const AFTER_USER_CHANGED = new signal.Signal('AFTER_USER_CHANGED');
